import React, {Component} from 'react';
import VideoContainer from "../../utils/VideoContainer";
import PropTypes from "prop-types";

class AccessoriesVideoSmall extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    }

    getItems() {

        if (this.props.videoList.length > 0) {
            return this.props.videoList.map(
                (v) => <VideoContainer key={'video-' + v.video_id}
                                       videoId={v.video_id}
                                       videoTitle={v.video_title}
                                       videoLength={v.video_length}
                                       videoDisabled={(v.video_disabled === 'true')}
                                       videoSource={this.props.source}
                                       classes={'col-lg-2'}
                                       onClick={this.props.onClick}
                />
            );
        }

        return this.translate('noVideosFound');

    }

    render() {

        let items = this.getItems();

        return items;

    }

}

export default AccessoriesVideoSmall;